/**
 * Target origin for postMessage calls from the embedded app to its host — always the exact
 * parent origin, never '*', so PII (URL / booking state) can't leak. Firefox censors both
 * ancestorOrigins and referrer behind referrer-policy and serializes censored entries as the
 * opaque-origin string "null", which postMessage rejects as a target. Unknown parent → the
 * app's own origin: the browser only delivers that to a same-origin parent, so it never leaks.
 */
export function resolveHostTargetOrigin(view: Window, referrer: string): string {
  const ancestors: DOMStringList | undefined = view.location.ancestorOrigins;
  const ancestor: string | null = ancestors && ancestors.length > 0 ? ancestors[0] : null;
  if (isPostableOrigin(ancestor)) {
    return ancestor;
  }
  const referrerOrigin: string | null = referrer ? new URL(referrer).origin : null;
  if (isPostableOrigin(referrerOrigin)) {
    return referrerOrigin;
  }
  return view.location.origin;
}

function isPostableOrigin(origin: string | null): origin is string {
  return !!origin && origin !== 'null';
}
